import { cn } from '@navinc/base-react-components'
import { FC, ReactNode } from 'react'

import { InteractionContextProvider } from '../../_providers/InteractionContextProvider/InteractionContextProvider.jsx'

export const RouteBody: FC<{
  children: ReactNode
  className?: string
}> = ({ children, className }) => {
  return (
    <div className={cn('w-full grow', className)}>
      <InteractionContextProvider elementLocation="body">{children}</InteractionContextProvider>
    </div>
  )
}
